"use strict";
/**
 * AUTO-GENERATED CONTRACT REGISTRY - DO NOT EDIT
 *
 * Generated by: tools/generate-contracts.ts
 * Run: pnpm generate:contracts
 *
 * This registry provides a single source of truth for all active contracts.
 * Generators in server-v2, web-v2, and mobile should import from here.
 *
 * Contracts are grouped by domain:
 * - customer: Customer-facing API endpoints
 * - merchant: Merchant dashboard endpoints
 * - public: Public/unauthenticated endpoints
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.contractRegistry = void 0;
const customer_1 = require("./customer");
const merchant_1 = require("./merchant");
const public_1 = require("./public");
/**
 * Contract registry organized by domain.
 * Only includes contracts that are actively exported (not commented out).
 */
exports.contractRegistry = {
    customer: [
        customer_1.CustomerProfileContract,
        customer_1.CustomerWalletContract,
        customer_1.CustomerSharingContract,
        customer_1.CustomerPointsContract,
        customer_1.CustomerMembershipContract,
        customer_1.CustomerNotificationsContract,
        customer_1.CustomerMemberCardsContract,
    ],
    merchant: [
        merchant_1.MerchantProfileContract,
        merchant_1.MerchantDashboardContract,
        merchant_1.MerchantCouponsContract,
        merchant_1.MerchantMembersContract,
        merchant_1.MerchantRedemptionContract,
        merchant_1.MerchantCreditsContract,
        merchant_1.MerchantTransactionsContract,
    ],
    public: [
        public_1.PublicSharingContract,
        public_1.PublicMerchantContract,
    ],
    /**
     * Get all contracts across all domains
     */
    all() {
        return [
            ...this.customer,
            ...this.merchant,
            ...this.public,
        ];
    },
    /**
     * Find a contract by name
     */
    byName(name) {
        return this.all().find(c => c.name === name);
    },
    /**
     * Get contracts for a specific domain
     */
    byDomain(domain) {
        return this[domain];
    },
};
